module.exports = __webpack_public_path__ + "img/about-companyy.b2faa45a.png";